import { LayoutLogged } from '../layout/LayoutLogged'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LayoutNotLogged } from '../layout/LayoutNotLogged'
import { LayoutOnboarding } from '../layout/LayoutOnboarding'
import OnboardingInstagram from '../pages/onboarding/OnboardingInstagram'
import OnboardingRegistration from '../pages/onboarding/OnboardingRegistration'

const OnboardingRoutes = () => {
  return (
    <Routes>
      <Route element={<LayoutOnboarding />}>
        <Route element={<LayoutNotLogged />}>
          <Route path="registration" element={<OnboardingRegistration />} />
        </Route>
        <Route element={<LayoutLogged />}>
          <Route path="instagram" element={<OnboardingInstagram />} />
        </Route>
        <Route index element={<Navigate to="/auth/login" />} />
        <Route path="*" element={<Navigate to="/auth/login" />} />
      </Route>
    </Routes>
  )
}

export default OnboardingRoutes
